var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21045"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#235594"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3476 13.8244C14.4464 13.9138 14.5953 13.9059 14.69 13.8123C15.4702 13.0415 16.4835 12.5934 17.5988 12.5345C19.8257 12.4347 21.7442 14.0027 22.1394 16.1371C22.1662 16.2817 22.0529 16.4152 21.9061 16.422L20.9322 16.467C20.712 16.4771 20.614 16.7487 20.7771 16.8971L23.5999 19.4647C23.7012 19.5566 23.8578 19.5492 23.9496 19.4477L26.5095 16.6219C26.6573 16.4587 26.5343 16.1984 26.3145 16.2089L25.0066 16.2712C24.6396 12.452 21.329 9.55097 17.454 9.73003C15.6146 9.82763 13.9012 10.5931 12.6177 11.9167C12.5209 12.0165 12.5292 12.1786 12.6322 12.272L14.3476 13.8244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.67358 18.2739H9.90563C10.0311 18.2739 10.1339 18.3683 10.149 18.4927C10.3565 20.194 11.1143 21.7771 12.3377 23.0009C13.7994 24.4562 15.7354 25.2654 17.7916 25.2654C19.7633 25.2795 21.6247 24.5459 23.0608 23.1969C23.162 23.1019 23.162 22.9396 23.0638 22.8414L21.1306 20.9082C20.2476 21.7932 19.0561 22.2871 17.7916 22.2871C16.5365 22.2871 15.3581 21.7818 14.4562 20.8889C13.8151 20.2478 13.3911 19.4415 13.2124 18.5738C13.1814 18.4233 13.3026 18.2842 13.4562 18.2842H14.5013C14.7215 18.2842 14.8318 18.0182 14.6766 17.8624L11.7674 14.9433C11.671 14.8466 11.5144 14.8464 11.4178 14.9427L8.49895 17.8513C8.34288 18.0069 8.45298 18.2739 8.67358 18.2739Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusLogo);
export default __webpack_public_path__ + "static/media/StatusLogo.ce05af8450ce1efafb506db42f2c170b.svg";
export { ForwardRef as ReactComponent };